import { twClassMerge } from '@healthhub/react-ui';
import { Grid, Typography } from 'antd';
import { useTranslation } from 'react-i18next';


const { Link, Text } = Typography;

const { useBreakpoint } = Grid;

interface EmptyStateScreenProps {
  emptyImg: string;
  errorMessage?: string;
  errorTitle?: string;
  isCovidPage?: boolean;
  namePage: string;
}

const EmptyStateScreen = ({
  emptyImg,
  errorMessage,
  errorTitle,
  isCovidPage = false,
  namePage,
}: EmptyStateScreenProps) => {
  const { t } = useTranslation();
  const breakpoints = useBreakpoint();

  return (
    <div className="px-4 pt-14 text-center">
      <div className="mb-12 flex justify-center">
        <img alt="" data-testid="empty-img" src={emptyImg} />
      </div>
      <div
        className={twClassMerge({
          'px-28': breakpoints.xl || breakpoints.xxl || breakpoints.lg || breakpoints.md,
        })}
      >
        <Text className="text-sm mb-6 inline-block font-semibold">
          {errorTitle ?? t(isCovidPage ? 'emptyState.title.covidRecord' : 'emptyState.title.radiology', { namePage })}
        </Text>
        <br />
        <Text className="text-sm mb-6 inline-block whitespace-pre-wrap">
          {errorMessage || t('emptyState.description')}
        </Text>
        <br />
        <Text className="text-sm inline-block">
          {t('emptyState.contactUs')}&nbsp;
          <Link className="email-link font-semibold text-blue-700" href="mailto:contact_us@healthhub.sg">
            contact_us@healthhub.sg.
          </Link>
        </Text>
      </div>
    </div>
  );
};

export default EmptyStateScreen;
